import { useQuery } from '@tanstack/react-query'

import { OperatorProfile } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

export const OPERATOR_PROFILE_KEY = 'operator-profile'

export type OperatorProfileRole =
  | 'new_user'
  | 'applicant'
  | 'account_owner'
  | 'trainee'
  | 'customer'
  | 'admin'
  | 'bot'
  | 'platform_user'
  | 'operator'

export type GetOperatorProfileResponse = {
  operatorProfileId: string
  active: boolean
  allowedProgramlessEngagements: boolean
  isFullTime: boolean
  isWorkforceManaged: boolean
  owner: {
    appUserId: string
    avatarUrl?: string
    dateCreated?: string
    email: string
    name: string
    role: OperatorProfileRole
    isActive: boolean
  }
}

export async function fetchOperatorProfile(operatorId: string): Promise<GetOperatorProfileResponse> {
  const { data } = await apiClient.get<GetOperatorProfileResponse>(`/int/v3/operators/${operatorId}/profile`)
  return data
}

export function useGetProfile(operatorId?: string) {
  return useQuery({
    queryKey: [OPERATOR_PROFILE_KEY, operatorId],
    queryFn: () => fetchOperatorProfile(operatorId as string),
    enabled: Boolean(operatorId),
    refetchOnWindowFocus: false,
  })
}

export function useGetActiveOperatorProfiles() {
  return useQuery({
    queryKey: ['active-operator-profiles'],
    queryFn: async () => {
      const response = await apiClient.get<OperatorProfile[]>('int/operator_profile', {
        params: { active: 'true', orderBy: 'owner.name', sortDescending: false },
      })

      return response.data ?? []
    },
    select: (data) => data.map((profile) => profile.owner),
  })
}
